/**
 * This is separate from the panel-config to avoid circular reference - the grids use this for
 * saved views and filter groups.
 */
export const Transactions2Key = 'transactions-2-w9k4x' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
